import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import FormContainer from "./FormContainer";
import HeaderOfModal from "./HeaderOfModal";

export default function ContactFormModal({ handleOpen, isIncludeGeoData }) {
  const [isClosed, setIsClosed] = useState(false);
  const [isMouseDownInside, setIsMouseDownInside] = useState(false);

  useEffect(() => {
    const isOverflowHidden = window.getComputedStyle(document.body).overflow === "hidden";
    if (isOverflowHidden) return;

    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollBarWidth}px`;

    return () => {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0px";
    };
  }, []);

  const handleMouseDown = () => {
    setIsMouseDownInside(true);
  };

  const handleMouseUp = (e) => {
    if (!isMouseDownInside && e.target === e.currentTarget) {
      handleClose();
    }
    setIsMouseDownInside(false);
  };

  const handleClose = () => {
    setIsClosed(true);
    setTimeout(handleOpen, 300);
  };

  return ReactDOM.createPortal(
    <Modal>
      <ModalOverlay closing={isClosed} onMouseUp={handleMouseUp}>
        <ModalContent closing={isClosed} onMouseDown={handleMouseDown}>
          <HeaderOfModal handleOpen={handleClose} />
          <FormContainer isIncludeGeoData={isIncludeGeoData} />
        </ModalContent>
      </ModalOverlay>
    </Modal>,
    document.body
  );
}

const Modal = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  overflow: hidden;
  /* backdrop-filter: blur(5px);
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000; */
`;

const ModalOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: safe center;
  padding: 10px;
  animation: ${({ closing }) => (closing ? "fadeOut" : "fadeIn")} 0.3s ease forwards;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

const ModalContent = styled.div`
  background-color: #fff;
  width: 100%;
  max-width: 500px;
  padding: 25px;
  border-radius: 8px;

  animation: ${({ closing }) => (closing ? "scaleOut" : "scaleUp")} 0.3s ease forwards;

  @keyframes scaleUp {
    from {
      transform: scale(0);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes scaleOut {
    from {
      transform: scale(1);
      opacity: 1;
    }
    to {
      transform: scale(0);
      opacity: 0;
    }
  }
`;
